var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from 'graphql-tag';
var CREATE_SUBSCRIPTION = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation createRefreshmentsSubscription {\n    createRefreshmentsSubscription {\n      id\n      status\n      dateCreated\n    }\n  }\n"], ["\n  mutation createRefreshmentsSubscription {\n    createRefreshmentsSubscription {\n      id\n      status\n      dateCreated\n    }\n  }\n"])));
export default CREATE_SUBSCRIPTION;
var templateObject_1;
